/* ============================================================
   BULL BAY RODS — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Countdown timer ── */
  function initCountdown() {
    var el = document.getElementById('bbr-countdown');
    if (!el) return;
    var target = new Date(el.dataset.target);

    function update() {
      var now  = Date.now();
      var diff = target.getTime() - now;
      if (diff <= 0) {
        el.innerHTML = '<p style="color:var(--bbr-tan);font-family:var(--font-heading);font-size:1.5rem;font-weight:900;text-transform:uppercase;letter-spacing:0.15em;">Available Now</p>';
        return;
      }
      var days    = Math.floor(diff / 86400000);
      var hours   = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      var pad = function(n) { return String(n).padStart(2, '0'); };

      el.querySelector('[data-days]').textContent    = pad(days);
      el.querySelector('[data-hours]').textContent   = pad(hours);
      el.querySelector('[data-minutes]').textContent = pad(minutes);
      el.querySelector('[data-seconds]').textContent = pad(seconds);
    }

    update();
    setInterval(update, 1000);
  }

  /* ── Limited Runs tab switcher ── */
  function initLimitedRunsTabs() {
    var buttons = document.querySelectorAll('.bbr-lr-tab-btn');
    var panels  = document.querySelectorAll('.bbr-lr-panel');
    if (!buttons.length) return;

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.dataset.tab;

        buttons.forEach(function(b) { b.classList.remove('is-active'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); });

        btn.classList.add('is-active');
        var panel = document.getElementById('bbr-lr-panel-' + target);
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* ── Sticky header scroll effect ── */
  function initStickyHeader() {
    var header = document.getElementById('bbr-header');
    if (!header) return;
    var lastY = 0;
    window.addEventListener('scroll', function() {
      var y = window.scrollY;
      if (y > 100) {
        header.style.boxShadow = '0 4px 24px rgba(0,0,0,0.5)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastY = y;
    }, { passive: true });
  }

  /* ── Rod Selector (filter chips) ── */
  function initRodSelector() {
    var chips = document.querySelectorAll('.bbr-selector__chip');
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        var group = chip.closest('.bbr-selector__chips');
        group.querySelectorAll('.bbr-selector__chip').forEach(function(c) {
          c.classList.remove('is-selected');
        });
        chip.classList.add('is-selected');
      });
    });
  }

  /* ── Image zoom on product page ── */
  function initProductImageZoom() {
    var mainImg = document.querySelector('.bbr-product-image-main img');
    var thumbs  = document.querySelectorAll('.bbr-product-thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = thumb.dataset.src || thumb.src;
        thumbs.forEach(function(t) { t.style.opacity = '0.5'; });
        thumb.style.opacity = '1';
      });
    });
  }

  /* ── Add to cart ── */
  function initAddToCart() {
    var form = document.querySelector('.bbr-atc-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.bbr-add-to-cart');
      var variantSelect = form.querySelector('[name="id"]');
      if (!variantSelect) return;

      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantSelect.value, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added ✓';
        btn.style.background = 'var(--bbr-green)';
        btn.style.color = '#ffffff';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2000);
        return fetch('/cart.js');
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badges = document.querySelectorAll('.bbr-cart-count');
        badges.forEach(function(b) { b.textContent = cart.item_count; });
      })
      .catch(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  }

  /* ── Init all ── */
  document.addEventListener('DOMContentLoaded', function() {
    initCountdown();
    initLimitedRunsTabs();
    initStickyHeader();
    initRodSelector();
    initProductImageZoom();
    initAddToCart();
  });

})();
